<template>
  <van-badge
    class="h-32 flex items-center"
    :content="aiShoppingStore.cartCount"
    :max="99"
    :offset="[-7, 10]"
    @click="handleNavigateToCart"
  >
    <img src="@/assets/images/ai-chat/nav-cart.png" class="size-32 mr-2" />
  </van-badge>
  <template></template>
</template>
<script setup lang="ts">
import { checkJsApi, navigateToCart } from "@voghion/native-api";
import { onMounted, onUnmounted, ref } from "vue";
import { useAiShoppingStore } from "@/states/ai-shopping";
import { showUpdateTips } from "./utils/update-tips";
import { useSetting } from "@/composables/use-setting";
import { useI18n } from "vue-i18n";

const aiShoppingStore = useAiShoppingStore();

const isSupportNavigateToCart = ref(false);
const { getClientInfo } = useSetting();
const clientInfo = getClientInfo();
const { t } = useI18n();

onMounted(() => {
  checkJsApi({
    api: navigateToCart,
  }).then((res) => {
    console.log("navigateToCart", res);
    isSupportNavigateToCart.value = res.result;
  });
});

const handleNavigateToCart = () => {
  if (isSupportNavigateToCart.value) {
    navigateToCart({});
  } else {
    showUpdateTips(clientInfo.country, t);
  }
};

let timer: NodeJS.Timeout | null = null;

onMounted(async () => {
  aiShoppingStore.getCartCount();
  timer = setInterval(() => {
    aiShoppingStore.getCartCount();
  }, 1000);
});

onUnmounted(() => {
  timer && clearInterval(timer);
});
</script>
<style lang="scss"></style>
